// extracted by mini-css-extract-plugin
export var buttonContainer = "_48-6";
export var centeredToolbar = "_48-4";
export var dashdraw = "_48-c";
export var emptyStateContainer = "_48-8";
export var emptyStateText = "_48-9";
export var flowEditor = "_48-0";
export var flowEditorContainer = "_48-7";
export var hovered = "_48-1";
export var leftPanel = "_48-3";
export var mainCanvasContainer = "_48-a";
export var minimap = "_48-b";
export var selectMode = "_48-2";
export var toolbarSeparator = "_48-5";